import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix for default markers in react-leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

// Country coordinates mapping
const countryCoordinates = {
  'United States': [39.8283, -98.5795],
  'Canada': [56.1304, -106.3468],
  'Brazil': [-14.2350, -51.9253],
  'United Kingdom': [54.7584, -2.6953],
  'Nigeria': [9.0820, 8.6753],
  'Kenya': [0.1769, 37.9062],
  'South Africa': [-30.5595, 22.9375],
  'Turkey': [38.9637, 35.2433],
  'United Arab Emirates': [23.4241, 53.8478],
  'China': [35.8617, 104.1954],
  'Russia': [61.5240, 105.3188],
  'Australia': [-25.2744, 133.7751]
};

const WorldMapCard = ({ worldMapData, height = '600px', width = '100%' }) => {
  // Use provided data or fallback to empty array
  const mapData = worldMapData?.countries || [];
  
  // Create custom icon for each marker with count
  const createCustomIcon = (count) => {
    return L.divIcon({
      className: 'custom-marker',
      html: `<div style="
        background-color: #3182ce;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        border: 2px solid white;
        box-shadow: 0 2px 8px rgba(0,0,0,0.3);
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-weight: bold;
        font-size: 12px;
      ">${count > 999 ? Math.floor(count/1000) + 'k' : count}</div>`,
      iconSize: [30, 30],
      iconAnchor: [15, 15]
    });
  };

  return (
    <div style={{ height, width, borderRadius: '8px', overflow: 'hidden' }}>
      <MapContainer 
        center={[20, 0]} 
        zoom={1} 
        scrollWheelZoom={false}
        style={{ height: '100%', width: '100%' }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {mapData.map((country, index) => {
          const coordinates = countryCoordinates[country.country] || [0, 0];
          return (
            <Marker 
              key={index} 
              position={coordinates}
              icon={createCustomIcon(country.count)}
            >
              <Popup>
                <div style={{ 
                  padding: '10px', 
                  minWidth: '120px',
                  textAlign: 'center',
                  fontFamily: 'Arial, sans-serif'
                }}>
                  <div style={{ fontSize: '32px', marginBottom: '8px' }}>
                    {country.flag}
                  </div>
                  <div style={{ 
                    fontSize: '16px', 
                    fontWeight: 'bold',
                    marginBottom: '5px'
                  }}>
                    {country.country}
                  </div>
                  <div style={{ 
                    fontSize: '20px', 
                    color: '#3182ce',
                    fontWeight: 'bold'
                  }}>
                    {country.count.toLocaleString()} users
                  </div>
                </div>
              </Popup>
            </Marker>
          );
        })}
      </MapContainer>
    </div>
  );
};

export default WorldMapCard;
